module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/5-e3baafeb6556bce622784728c38377c5.png";